import { default as _91id_93FsEWFdpPLbMeta } from "/home/denis/sources/nova-plateform-web/pages/[id].vue?macro=true";
import { default as accountvxlxvmAsBPMeta } from "/home/denis/sources/nova-plateform-web/pages/account.vue?macro=true";
import { default as accept_45invitezI3ozJPd8kMeta } from "/home/denis/sources/nova-plateform-web/pages/admin/accept-invite.vue?macro=true";
import { default as reset_45password1UmcQkeB4JMeta } from "/home/denis/sources/nova-plateform-web/pages/admin/reset-password.vue?macro=true";
import { default as indexmKhFsQ65CLMeta } from "/home/denis/sources/nova-plateform-web/pages/index.vue?macro=true";
import { default as login12GeA0JQCEMeta } from "/home/denis/sources/nova-plateform-web/pages/login.vue?macro=true";
import { default as reset_45passwordDnKunufRBCMeta } from "/home/denis/sources/nova-plateform-web/pages/reset-password.vue?macro=true";
export default [
  {
    name: _91id_93FsEWFdpPLbMeta?.name ?? "id",
    path: _91id_93FsEWFdpPLbMeta?.path ?? "/:id()",
    meta: _91id_93FsEWFdpPLbMeta || {},
    alias: _91id_93FsEWFdpPLbMeta?.alias || [],
    redirect: _91id_93FsEWFdpPLbMeta?.redirect,
    component: () => import("/home/denis/sources/nova-plateform-web/pages/[id].vue").then(m => m.default || m)
  },
  {
    name: accountvxlxvmAsBPMeta?.name ?? "account",
    path: accountvxlxvmAsBPMeta?.path ?? "/account",
    meta: accountvxlxvmAsBPMeta || {},
    alias: accountvxlxvmAsBPMeta?.alias || [],
    redirect: accountvxlxvmAsBPMeta?.redirect,
    component: () => import("/home/denis/sources/nova-plateform-web/pages/account.vue").then(m => m.default || m)
  },
  {
    name: accept_45invitezI3ozJPd8kMeta?.name ?? "admin-accept-invite",
    path: accept_45invitezI3ozJPd8kMeta?.path ?? "/admin/accept-invite",
    meta: accept_45invitezI3ozJPd8kMeta || {},
    alias: accept_45invitezI3ozJPd8kMeta?.alias || [],
    redirect: accept_45invitezI3ozJPd8kMeta?.redirect,
    component: () => import("/home/denis/sources/nova-plateform-web/pages/admin/accept-invite.vue").then(m => m.default || m)
  },
  {
    name: reset_45password1UmcQkeB4JMeta?.name ?? "admin-reset-password",
    path: reset_45password1UmcQkeB4JMeta?.path ?? "/admin/reset-password",
    meta: reset_45password1UmcQkeB4JMeta || {},
    alias: reset_45password1UmcQkeB4JMeta?.alias || [],
    redirect: reset_45password1UmcQkeB4JMeta?.redirect,
    component: () => import("/home/denis/sources/nova-plateform-web/pages/admin/reset-password.vue").then(m => m.default || m)
  },
  {
    name: indexmKhFsQ65CLMeta?.name ?? "index",
    path: indexmKhFsQ65CLMeta?.path ?? "/",
    meta: indexmKhFsQ65CLMeta || {},
    alias: indexmKhFsQ65CLMeta?.alias || [],
    redirect: indexmKhFsQ65CLMeta?.redirect,
    component: () => import("/home/denis/sources/nova-plateform-web/pages/index.vue").then(m => m.default || m)
  },
  {
    name: login12GeA0JQCEMeta?.name ?? "login",
    path: login12GeA0JQCEMeta?.path ?? "/login",
    meta: login12GeA0JQCEMeta || {},
    alias: login12GeA0JQCEMeta?.alias || [],
    redirect: login12GeA0JQCEMeta?.redirect,
    component: () => import("/home/denis/sources/nova-plateform-web/pages/login.vue").then(m => m.default || m)
  },
  {
    name: reset_45passwordDnKunufRBCMeta?.name ?? "reset-password",
    path: reset_45passwordDnKunufRBCMeta?.path ?? "/reset-password",
    meta: reset_45passwordDnKunufRBCMeta || {},
    alias: reset_45passwordDnKunufRBCMeta?.alias || [],
    redirect: reset_45passwordDnKunufRBCMeta?.redirect,
    component: () => import("/home/denis/sources/nova-plateform-web/pages/reset-password.vue").then(m => m.default || m)
  }
]